/**
 * Welcome Message Utilities
 * Provides language-specific welcome messages for chat agents
 */

/**
 * Get welcome message based on agent name and language
 * @param {string} agentName - Name of the agent
 * @param {string} language - Language setting of the agent
 * @returns {string} Localized welcome message
 */
export const getWelcomeMessage = (agentName, language) => {
  const welcomeMessages = {
    English: `Hello! I'm ${agentName}. How can I help you today?`,
    Hindi: `नमस्ते! मैं ${agentName} हूँ। आज मैं आपकी कैसे मदद कर सकता हूँ?`,
    Chinese: `你好！我是${agentName}。今天我能为您做些什么？`,
    Japanese: `こんにちは！私は${agentName}です。今日はどのようにお手伝いできますか？`,
    Thai: `สวัสดี! ฉันคือ${agentName} วันนี้ฉันจะช่วยคุณได้อย่างไร?`,
    Burmese: `မင်္ဂလာပါ! ကျွန်တော်က ${agentName} ပါ။ ဒီနေ့ ဘယ်လိုကူညီရမလဲ?`,
  };
  
  return welcomeMessages[language] || welcomeMessages.English;
};

/**
 * Get welcome message for voice agents (slightly different format)
 * @param {string} agentName - Name of the agent
 * @param {string} language - Language setting of the agent
 * @returns {string} Localized welcome message for voice agents
 */
export const getVoiceWelcomeMessage = (agentName, language) => {
  const voiceWelcomeMessages = {
    English: `Hello! I'm ${agentName}. How can I help you today?`,
    Hindi: `नमस्ते! मैं ${agentName} हूँ। आज मैं आपकी कैसे मदद कर सकता हूँ?`,
    Chinese: `你好！我是${agentName}。今天我能为您做些什么？`,
    Japanese: `こんにちは！私は${agentName}です。今日はどのようにお手伝いできますか？`,
    Thai: `สวัสดี! ฉันคือ${agentName} วันนี้ฉันจะช่วยคุณได้อย่างไร?`,
    Burmese: `မင်္ဂလာပါ! ကျွန်တော်က ${agentName} ပါ။ ဒီနေ့ ဘယ်လိုကူညီရမလဲ?`,
  };
  
  return voiceWelcomeMessages[language] || voiceWelcomeMessages.English;
};

/**
 * Get simple welcome message based on language (without agent name)
 * Matches the format "Hello! How can I help you today?"
 * @param {string} language - Language setting of the agent
 * @returns {string} Localized welcome message
 */
export const getSimpleWelcomeMessage = (language) => {
  const welcomeMessages = {
    English: 'Hello! How can I help you today?',
    Hindi: 'नमस्ते! आज मैं आपकी कैसे मदद कर सकता हूँ?',
    Chinese: '你好！今天我能为您做些什么？',
    Japanese: 'こんにちは！今日はどのようにお手伝いできますか？',
    Thai: 'สวัสดี! วันนี้ฉันจะช่วยคุณได้อย่างไร?',
    Burmese: 'မင်္ဂလာပါ! ဒီနေ့ ဘယ်လိုကူညီရမလဲ?',
  };
  
  return welcomeMessages[language] || welcomeMessages.English;
};




